import React from 'react';
import { InspirationalSearchSelector } from './InspirationalSearchSelector';

export function InspirationalSearchSelectorSource() {
    return {
        render: ({ onClickItem } = {}) => {
            return (
                <InspirationalSearchSelector
                    key="inspirational-selector"
                    onClickItem={onClickItem}
                />
            );
        },
    };
}
